import "../../models/address_group.js";
import "../base.js";
import "../../../../controllers/physicians/show/profile_map.js";
import "../../../../utilities/appointment_date.js";
import "./suggestion_selector/confirmation_modal.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Views ??= {};
window.AppointmentBooking.SlotSuggester.Views.Reselector ??= {};

const __SuggestionSelectorPrior = AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector;

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector = class SuggestionSelector extends (
  AppointmentBooking.SlotSuggester.Views.Base
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
    this.addressGroups = this.addressGroups.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    this.confirmationModalModel = new this.Models.ConfirmationModal();
    this.confirmationModal = new this.Views.ConfirmationModal({
      model: this.confirmationModalModel,
      appendTo: this.el,
    }).hide();

    // BEHAVIOUR

    return this.listenTo(
      this.model,
      "reset change:selectedProviderOption change:desiredStartTime change:selectedSlotId",
      this.render,
    );
  }

  // EVENT HANDLERS

  handleStartTimeClick(event) {
    const startTime = jQuery(event.currentTarget).data("slot-start-time");
    const confirmationModalSlots = new this.Collections.Slots(this.currentSlots.where({ startTime }));
    this.confirmationModalModel.set({ selectedDate: startTime, slots: confirmationModalSlots });
    return this.confirmationModal.show();
  }

  // RENDERING

  render() {
    // Add classes that will aid in styling depending on which list of slots is showing
    this.$el.toggleClass("--desired-provider-slots", this.selectedProviderOption === "desired");
    this.$el.toggleClass("--pool-slots", this.selectedProviderOption === "pool");
    super.render(...arguments);

    this.$el.find('[data-behaviour="sp-address-card-map-container"]').each(
      (index, mapContainer) =>
        new Sparkle.Views.PhysicianProfileMap({
          el: mapContainer,
          collection: [JSON.parse(mapContainer.dataset.address)],
        }),
    );

    return this;
  }

  contextForRender() {
    const context = super.contextForRender(...arguments);

    if (
      context.suggestionAlgorithmKey === "with_any_provider_location" ||
      context.suggestionAlgorithmKey === "with_provider_location"
    ) {
      context.showMessage = false;
    } else {
      context.showMessage = true;
    }

    context.addressGroups = this.addressGroups().toJSON();
    context.compactDisplay =
      this.model.get("selectedProviderOption") === "desired" &&
      context.addressGroups.length === 1 &&
      context.addressGroups[0].isDesiredDepartmentId;

    return context;
  }

  // HELPER METHODS

  addressGroups() {
    return this.Models.AddressGroup.createAll(this.currentSlots, {
      limit: this.maxTimeSlots,
      desiredStartTime: this.desiredStartTime,
      desiredDepartmentId: this.desiredDepartmentId,
      selectedProvider: this.selectedProvider,
      selectedSlotId: this.selectedSlotId,
    });
  }
};

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.prototype.tagName = "div";
AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.prototype.template =
  "reselector/suggestion_selector";
AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.prototype.className =
  "appointment-booking-slot-reselector__suggestion-selector";
AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.prototype.maxTimeSlots = 3;
AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.prototype.events = {
  "click [data-slot-start-time]": "handleStartTimeClick",
};

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.get("currentSlots", function () {
  return this.model.get(this.selectedProviderOption === "desired" ? "desiredProviderSlots" : "poolSlots");
});

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.get("selectedProvider", function () {
  if (this.selectedSlotId != null) {
    return this.model.get("suggestedSlots").get(this.selectedSlotId).get("provider");
  }
});

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.get("selectedProviderOption", function () {
  return this.model.get("selectedProviderOption");
});

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.get("selectedDate", function () {
  return this.model.get("selectedDate");
});

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.get("selectedSlotId", function () {
  return this.model.get("selectedSlotId");
});

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.get("desiredStartTime", function () {
  return this.model.get("desiredStartTime");
});

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.get("desiredDepartmentId", function () {
  return this.model.get("desiredDepartmentId");
});

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.get("desiredProvider", function () {
  return this.model.get("desiredProvider");
});

AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector.get("availableProviders", function () {
  return this.model.get("availableProviders");
});

if (__SuggestionSelectorPrior) {
  Object.assign(AppointmentBooking.SlotSuggester.Views.Reselector.SuggestionSelector, __SuggestionSelectorPrior);
}
